import { UIMessage } from "ai";
import { SaveEvent } from "../../create/actions";
import {
    createEventFormSchema,
    CreateEventFormSchema,
} from "../../create/utils";
import { z } from "zod";
import {
    CreateEventWithAIInput,
    createEventWithAISchema,
} from "~/app/api/chat/validation";
import { CreateEventWithAI } from "~/app/api/chat/actions";

export const saveEventOutput = z.custom<SaveEvent>();
const tools = {
    createEvent: {
        input: createEventWithAISchema,
        output: z.object({
            success: z.boolean(),
            eventSlug: z.string(),
        }),
    },
};

enum AIEventCreationTools {
    createEvent = "createEvent",
}

export type ParsedToolInovcation = {
    toolName: AIEventCreationTools.createEvent;
    args: CreateEventWithAIInput;
    result: {
        success: boolean;
        eventSlug: string;
    };
};

class AIMessageParser {
    /**
     * Parses tool invocations from the messages array.
     * @param messages The array of message from useChat
     * @returns An array of parsed tool invocations
     */
    parseToolInvocations(messages: UIMessage[]): ParsedToolInovcation[] {
        const invocations: ParsedToolInovcation[] = [];

        for (const message of messages) {
            if (message.role === "assistant" && message.toolInvocations) {
                for (const invocation of message.toolInvocations) {
                    if (invocation.state === "result") {
                        const toolName = invocation.toolName;
                        let parsedArgs;
                        let parsedResult;

                        try {
                            switch (toolName) {
                                case AIEventCreationTools.createEvent:
                                    parsedArgs = tools.createEvent.input.parse(
                                        invocation.args,
                                    );
                                    parsedResult =
                                        tools.createEvent.output.parse(
                                            invocation.result,
                                        );
                                    if (!parsedResult) {
                                        throw new Error("Invalid result");
                                    } else {
                                        invocations.push({
                                            toolName,
                                            args: parsedArgs,
                                            result: parsedResult,
                                        });
                                    }
                                    break;

                                default:
                                    console.error(
                                        `Unknown tool name: ${toolName}`,
                                    );
                                    break;
                            }
                        } catch (error) {
                            if (error instanceof z.ZodError) {
                                console.error(
                                    `Schema validation error for ${toolName}:`,
                                    error.errors,
                                );
                            } else {
                                console.error(
                                    `Error parsing ${toolName} invocation:`,
                                    error,
                                );
                            }
                        }
                    }
                }
            }
        }

        return invocations;
    }
}

export default AIMessageParser;
